var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExclamationOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 28,
    viewBox: "0 0 31 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4756 1.19149C14.3753 -0.397164 16.6247 -0.397162 17.5244 1.19149L30.6833 24.4255C31.5831 26.0142 30.4584 28 28.6589 28H2.34111C0.541606 28 -0.583082 26.0142 0.31667 24.4255L13.4756 1.19149ZM13.8692 10.3198C13.8196 9.38512 14.5641 8.60001 15.5001 8.60001C16.4361 8.60001 17.1805 9.38512 17.1309 10.3198L16.7091 18.2535C16.675 18.8963 16.1438 19.4 15.5001 19.4C14.8563 19.4 14.3251 18.8963 14.291 18.2535L13.8692 10.3198ZM15.5 24.2C16.1341 24.2 16.6481 23.6627 16.6481 23C16.6481 22.3372 16.1341 21.8 15.5 21.8C14.8659 21.8 14.3518 22.3372 14.3518 23C14.3518 23.6627 14.8659 24.2 15.5 24.2Z",
    fill: "#CE6D2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationOrange);
export default __webpack_public_path__ + "static/media/exclamation-orange.94a9d8e5cbed4dd9dc0eafd26671a9eb.svg";
export { ForwardRef as ReactComponent };